/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */

import {
  ROUTE_CLASSIFICATION_NOTIFICATION_MANAGEMENT,
  ROUTE_HOMEPAGE,
  ROUTE_PHARMACY_HOMEPAGE,
} from '../constants/urlConstants';
import i18next from 'i18next';
import sign from 'jwt-encode';
import { ROUTE_SYSTEM_ACCESS } from '../constants/urlConstants';
import { getDefaultAccess } from './defaultAccess';
import { redirectToMonitor } from './redirectToMonitor';

/** Roles com acesso total */
export const patientSafetyRole = '3e6854c6-aaf9-4cc5-bbe5-67b956a492f5';

/** Roles com acesso ao monitoramento */
export const observerRole = '057c50ce-bacb-4cbb-90dd-808b9d3620aa';
export const investigatorRole = 'ed6120ef-c361-4f00-99ab-6e56200a7cff';

/** Roles com acesso aos alertas */
export const leadershipRole = '5334a157-5dde-43d0-b0ec-742d504ed8a5';
export const alertsRole = 'ab55fae0-afe4-4ae1-a154-68aa4544f31a';

/** Roles com acesso único */
export const notifierRole = '1799422c-34be-4511-9ac4-255807a5e4f3';
export const notifierPharmacyRole = '37cbd896-b9a2-472b-91a7-1edb641e9a23';
export const responsibleActionPlanRole = '0f09a332-f342-4651-9410-9306c9a8ea41';
export const investigatorTeamRole = '2a980f70-4ed2-4fe7-a2d7-e751a46b8d13';
export const reportsRole = '4307f4a6-69e1-4b49-8161-ec3ad0fe3af3';
export const accountManagerRole = 'b855499d-4f9f-40ff-9ef4-d03e99df290c';
export const networkManagerRole = 'd01a9757-fa4e-4922-bed1-5dd839618207';
export const pharmacyManagerRole = '2d8a9e1f-de7e-40a1-ac40-10dd3dc2677e';
export const dashboardManageRole = '42144ccd-86df-4175-86cd-1266813ec171';
export const pharmacyClinicRole = '2d8a9e1f-de7e-40a1-ac40-10dd3dc2677e';

export const allowedRoles = [
  patientSafetyRole,
  observerRole,
  investigatorRole,
  notifierRole,
  notifierPharmacyRole,
  accountManagerRole,
  networkManagerRole,
  pharmacyClinicRole,
  reportsRole,
  dashboardManageRole,
];

/**
 * Informações selecionadas no modal de acesso
 */
export const defaultAccess = getDefaultAccess();

/**
 * Id da role selecionada no modal de acesso
 */
export const roleId = getDefaultAccess()?.roleId.toLowerCase();

/**
 * Roles não permitidas para visualizar certas áreas do monitoramento e notificação (Observer e Investigator)
 */
export const notPermittedRoles = [observerRole, investigatorRole];

/**
 * Checa se a role selecionada é uma das não permitidas (Observer ou Investigator)
 */
export const takeNotPermittedRoles = notPermittedRoles.find((role) =>
  role.includes(roleId),
);

/**
 * Checa se a role selecionada é Observer
 */
export const isObserverRole = roleId === observerRole;

/**
 * Checa se a role selecionada é Investigator
 */
export const isInvestigatorRole = roleId === investigatorRole;

/**
 * Checa se a role selecionada é Patient Safety
 */
export const isPatientSafetyRole = roleId === patientSafetyRole;

/**
 * Redirecionamento por role
 */

export const jwtTokenAccess = sign(defaultAccess, '');

export const takeUrlNavToVite = (route: string, access?: any) => {
  const newJwtTokenAccess = sign(access, '');
  const token =
    access && newJwtTokenAccess ? newJwtTokenAccess : jwtTokenAccess;
  return `${process.env.NEXT_PUBLIC_BASE_SITE_URL_SP_VITE}${route}/?tsa=${token}&CultureCode=${i18next.language}`;
};

export const takeRedirectRouteByRole = (role: string, access?: any) => {
  let route = ROUTE_HOMEPAGE;

  /** Retornando a homepage quando em desenvolvimento para não prejudicar o andamento do dev */
  if (process.env.NEXT_PUBLIC_BASE_SITE_URL_SP_VITE === 'Development')
    return ROUTE_HOMEPAGE;

  switch (role) {
    case patientSafetyRole:
    case investigatorRole:
    case observerRole:
      route = takeUrlNavToVite(
        ROUTE_CLASSIFICATION_NOTIFICATION_MANAGEMENT,
        access,
      );
      break;

    case notifierPharmacyRole:
      route = ROUTE_PHARMACY_HOMEPAGE;
      break;

    case pharmacyManagerRole:
      route = ROUTE_PHARMACY_HOMEPAGE;
      break;

    case networkManagerRole:
    case accountManagerRole:
      window.open(redirectToMonitor({
        destinationUrl: process.env.NEXT_PUBLIC_DASHBOARD_MEDICAL_INTELLIGENCE as string,
        roleId: role,
      }), '_blank');
      route = ROUTE_SYSTEM_ACCESS;
      break;

    default:
      break;
  }

  return route;
};
